<script>
  export let name = '';
</script>

<section>
  <div class="title">
    <h3>{name}</h3>
  </div>
  <slot />
</section>

<style>
  section {
    border: 2px solid #171717;
    border-radius: 5px;
    padding: 10px;
    margin: 10px;
  }

  .title {
    display: inline-block;
    padding: 0 5px;
    position: relative;
    top: -20px;
    background-color: #E7964B;
  }

</style>